"use strict";

import LocalAuthenticationStrategy from '../credentials-manager/localAuthenticationStrategy';
import LocalAuthenticationLevel from '../credentials-manager/localAuthenticationLevel';
const defaultLocalAuthOptions = {
  evaluationPolicy: LocalAuthenticationStrategy.deviceOwnerWithBiometrics,
  authenticationLevel: LocalAuthenticationLevel.strong
};
function addDefaultLocalAuthOptions(localAuthenticationOptions) {
  return {
    ...defaultLocalAuthOptions,
    ...localAuthenticationOptions
  };
}
export default addDefaultLocalAuthOptions;
//# sourceMappingURL=addDefaultLocalAuthOptions.js.map